<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->

        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>
                    <strong> Delete Employee </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row>
                <v-col cols="12" sm="3" md="3">
                    <v-autocomplete color="#0F2027" dense rounded required v-model="ay" :items="aylist" item-text="ay"
                        item-value="id" label="Select Academic Year" outlined persistent-hint
                        hint="Please select academic year" />
                </v-col>
                <v-col sm="6" md="6">
                    <v-autocomplete :items="emp_list" v-model="emp_data" item-text="name" label="Search Employee" dense
                        return-object rounded outlined :loading="comp_load"
                        placeholder="Search by Employee Code or name"></v-autocomplete>
                </v-col>
                <v-col sm="3" md="3">
                    <v-btn @click="getData();show=false" :loading="fetch_loader" class="button mt-1 pt-0">Fetch</v-btn>
                </v-col>
            </v-row>
            <span v-if="show ==  true">
                <span class="flash" v-if="coff_inst_id!=''"><strong>
                        <center>Examination data found of selected employee.</center>
                    </strong></span>
                <v-simple-table>
                    <tbody>
                        <tr>
                            <td><strong>Delete</strong></td>
                            <td><strong>Id Type</strong></td>
                            <td><strong>Id</strong></td>
                        </tr>
                        <tr v-if="emp_id!=''">
                            <td>
                                <v-avatar size="25" class="edit-avatar">
                                    <v-icon
                                        @click="delete_emp=true;delete_user=false;delete_login=false;delete_role=false;delete_coff_id=falsedelete_dialog=true"
                                        class="mr-4 v-icon-size" color="red">mdi-trash-can</v-icon>
                                </v-avatar>
                            </td>
                            <td><strong>Employee Id</strong></td>
                            <td>{{emp_id}}</td>
                        </tr>
                        <tr v-if="user_id!=''">
                            <td>
                                <v-avatar size="25" class="edit-avatar">
                                    <v-icon
                                        @click="delete_emp=false;delete_user=true;delete_login=false;delete_role=false;delete_coff_id=false;delete_dialog=true"
                                        class="mr-4 v-icon-size" color="red">mdi-trash-can</v-icon>
                                </v-avatar>
                            </td>
                            <td><strong>User Id</strong></td>
                            <td>{{user_id}}</td>
                        </tr>
                        <tr v-if="login_id!=''">
                            <td>
                                <v-avatar size="25" class="edit-avatar">
                                    <v-icon class="mr-4 v-icon-size"
                                        @click="delete_emp=false;delete_user=false;delete_login=true;delete_role=false;delete_coff_id=false;delete_dialog=true"
                                        color="red">mdi-trash-can</v-icon>
                                </v-avatar>
                            </td>
                            <td><strong>Login Id</strong></td>
                            <td>{{login_id}}</td>
                        </tr>
                        <tr v-if="roles_id!=''">
                            <td>
                                <v-avatar size="25" class="edit-avatar">
                                    <v-icon class="mr-4 v-icon-size"
                                        @click="delete_emp=false;delete_user=false;delete_login=false;delete_role=true;delete_coff_id=false;delete_dialog=true"
                                        color="red">mdi-trash-can</v-icon>
                                </v-avatar>
                            </td>
                            <td><strong>Roles Id</strong></td>
                            <td><span class="ml-3" v-for="role,index in roles_id" :key="index"> {{role}}</span></td>
                        </tr>
                        <tr v-if="coff_inst_id!=''">
                            <td>
                                <v-avatar size="25" class="edit-avatar">
                                    <v-icon class="mr-4 v-icon-size"
                                        @click="delete_emp=false;delete_user=false;delete_login=false;delete_role=false;delete_coff_id=true;delete_dialog=true"
                                        color="red">mdi-trash-can</v-icon>
                                </v-avatar>
                            </td>
                            <td><strong>Course Offering Id</strong></td>
                            <td><span class="ml-3" v-for="cl,index in coff_inst_id" :key="index"> {{cl}}</span></td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </span>
        </v-card>
        <v-dialog v-model="delete_dialog" max-width="500px">
            <v-card>
                <v-col cols="12" sm="12" md="12">
                    <v-card class="box">
                        <v-row dense justify="center">
                            <strong>Are sure want delete !!!!</strong>
                        </v-row>
                    </v-card>
                </v-col>
                <v-row dense justify="center">
                    <v-btn class="button" @click="deleteData()">Yes</v-btn>
                    <v-btn class="button" @click="delete_dialog = false">Close</v-btn>
                </v-row>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import axios from "axios";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },
        data: () => ({
            comp_load: false,
            emp_list: null,
            // extraBreadcrumbItems: [


            // ],
            // breadcrumbClass: "breadcrumb-style1",
            emp_data: null,
            fetch_loader: false,
            aylist: null,
            ay: null,
            emp_id: null,
            user_id: null,
            login_id: null,
            roles_id: null,
            coff_inst_id: null,
            show: false,
            delete_emp:false,
            delete_user:false,
            delete_login:false,
            delete_role:false,
            delete_coff_id:false,
            delete_dialog:false,
             snackbar_msg: "",
            color: "",
            snackbar: false,
        }),
        mounted() {
            this.comp_load = true;
            axios
                .post("/admission/getAllEmps")
                .then((res) => {
                    if (res.data.msg == "200") {
                        this.emp_list = res.data.emp_list;
                        this.aylist = res.data.ay_list;
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong!!!");
                })
                .finally(() => {
                    this.comp_load = false;
                });
        },
        methods: {
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            deleteData(){
                 const data = {
                    delete_emp:this.delete_emp,
                    delete_user:this.delete_user,
                    delete_login:this.delete_login,
                    delete_role:this.delete_role,
                    delete_coff_id:this.delete_coff_id,
                    eid: this.emp_data,
                    ay: this.ay,
                }
                axios
                    .post("/Academics/empIdDelete", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.showSnackbar("#4caf50", " Deleted Successfully..."); // show snackbar on success
                            this.delete_dialog = false
                            this.getData()
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                            this.delete_dialog = false
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        this.delete_dialog = false
                    })
                    .finally(() => {});
            },
            getData() {
               const data = {
                    eid: this.emp_data,
                    ay: this.ay,
                };
                axios
                    .post("/Academics/getInstructorIdDelete", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.emp_id = res.data.emp_id;
                            this.user_id = res.data.user_id;
                            this.login_id = res.data.login_id;
                            this.roles_id = res.data.roles_id;
                            this.coff_inst_id = res.data.coff_inst_id;
                            this.show = true;
                          //  this.showSnackbar("#4caf50", " Save Successfully..."); // show snackbar on success
                        } else {
                            this.showSnackbar("red", res.data.snackbar);
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {});
            },
        },
    };
</script>
<style>
    tr,
    td,
    th {
        border: 1px solid #ccc;
        text-align: center;
        font-size: small;
    }
    tr,
    tbody {
        border-bottom: 1px solid #ccc;
        border: 1px solid #ccc;
        font-size: small;
    }
    td {
        margin: 0.3rem !important;
        padding: 0.4rem !important;
        font-size: small;
    }
    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
            font-size: small;
        }
        td + td,
        th + th {
            width: auto;
            font-size: small;
        }
    }
    v-simple-table {
        white-space: nowrap !important;
        text-align: center;
        font-size: small;
    }
    .flash {
   animation-name: flash;
    animation-duration: 0.9s;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
    animation-direction: alternate;
    animation-play-state: running;
}

@keyframes flash {
    from {color: red;}
    to {color: white;}
}
</style>
